import { Box, Divider, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import { UserList } from './UserList';

export const AdminUsers = () => {
    const navigate = useNavigate();

    const handleCreateUser = () => {
        navigate('/admin/users/create');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100%',
                height: '100%',
            }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 3, pb: 2 }}>
                <Typography variant="h5">Users</Typography>
                <Button variant="contained" onClick={handleCreateUser}>
                    Create User
                </Button>
            </Box>
            <Divider />
            <UserList />
        </Box>
    );
};
